// extracted by mini-css-extract-plugin
export default {"Outer":"POSDefaults_Outer__fL18H","CloseButton":"POSDefaults_CloseButton__aYYTL","List":"POSDefaults_List__pvbzu","Open":"POSDefaults_Open__3hD8c"};